import { Link } from 'react-router';
import { Footer, Logo } from '../components/Brand';

export function Landing() {
  return (
    <div className="flex min-h-screen flex-col">
      <header className="border-b border-line">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3">
          <Logo label="Partner Hub" />
          <Link to="/signin" className="min-h-11 content-center text-sm text-ash hover:text-ink">
            Partner sign in
          </Link>
        </div>
      </header>
      <main className="mx-auto w-full max-w-6xl flex-1 px-4 py-16">
        <p className="eyebrow mb-3">MindHYVE Referral Partner Program</p>
        <h1 className="max-w-3xl text-4xl leading-tight font-light tracking-tight text-balance md:text-6xl">Bring Agentic AI to your network.</h1>
        <p className="mt-5 max-w-2xl text-lg text-ash">
          Earn 10% of collected revenue for the life of every client contract you refer. Individuals and firms, worldwide. The Partner Hub is where you apply, register leads, find materials,
          and follow your commission.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/apply" className="inline-flex min-h-11 items-center bg-gold px-6 font-mono text-[12px] tracking-[0.16em] text-bg uppercase hover:bg-gold-strong">
            Apply to become a partner
          </Link>
          <Link to="/signin" className="inline-flex min-h-11 items-center border border-line px-6 font-mono text-[12px] tracking-[0.16em] uppercase hover:border-gold">
            Sign in
          </Link>
          <a href="https://mindhyve.ai/partners/" className="inline-flex min-h-11 items-center px-2 text-sm text-ash hover:text-ink">
            About the program ↗
          </a>
        </div>
        <p className="mt-16 text-sm text-dim">
          MindHYVE staff: <Link className="underline hover:text-ink" to="/console">open the console</Link>.
        </p>
      </main>
      <Footer />
    </div>
  );
}
